<template>
  <Loading v-if="loading" />
  <div v-if="!status?.message && loading && !orderSMSCreate" class="pleaseWait">
    <p>{{ $t('pleaseWait') }}</p>
  </div>
  <div
    v-if="status?.message && !loading && !orderSMSCreate"
    class="signicatVerify__error"
  >
    <div class="error" role="alert">
      {{ $t(status.message) }}
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import Loading from '@/views/Loading.vue';

@Options({
  name: 'PaymentSMS',
  components: {
    Loading
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapState('orders', ['orderSMSCreate', 'status'])
  },
  created() {
    this.show();
  },
  methods: {
    ...mapActions('orders', ['getOrderPaymentData']),
    async show() {
      this.loading = true;

      const data = this.$route.query.data;
      const jsonData = JSON.parse(atob(data));

      await this.getOrderPaymentData({
        pharmacyId: jsonData.id,
        orderId: jsonData.orderId
      });

      if (this.orderSMSCreate) {
        this.redirectToPayment();
      }

      this.loading = false;
    },
    redirectToPayment() {
      window.location.href = this.orderSMSCreate.href;
    }
  }
})
export default class PaymentSMSComponent extends Vue {}
</script>

<style lang="scss" scoped>
.pleaseWait {
  p {
    position: absolute;
    top: 43%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-family: 'Ubuntu-Medium';
    font-size: $eighteenSize;
    line-height: $twentyOneSize;
    font-weight: 400;
  }
}

.signicatVerify__error {
  .error {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: $sixteenSize;
    line-height: $eighteenSize;
    font-weight: 400;
    color: $messageError;
  }
}
</style>
